import baseContextComponent from "@/components/baseContextComponent";
import {
	importTypes,
	tableImportMapping,
	tableImportMappingViewModel
} from "@/models/importModels";
import { tableItem } from "@/models/tableItem";
import api from "@/services/api";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class settingsTableMappingListPage extends baseContextComponent {
	isLoading: boolean = false;
	showModal: boolean = false;
	showModalCopy: boolean = false;
	showModalDuplicate: boolean = false;
	tableImportMapping: tableImportMapping = new tableImportMapping();
	tableConfigs: tableImportMapping[] = null;
	saveClicked: boolean = false;
	tables: tableItem[] = [];
	tableSelected: string | null = null;

	configurations: tableImportMapping[] = [];
	configurationSelected: number | null = null;
	configurationsForDuplicate: tableImportMapping[] = [];
	configurationForDuplicateSelected: number | null = null;
	get tableName(): string {
		return this.$route && this.$route.params && this.$route.params.name
			? this.$route.params.name
			: null;
	}

	@Watch("$route")
	onRouteChange(to, from) {
		var self = this;
		if (to.params.name != from.params.name) self.fetch();
	}
	get importTypesList() {
		return Object.keys(importTypes)
			.map(t => {
				return { value: t, text: t };
			})
			.filter(t => t.value == importTypes.XML || t.value == importTypes.CSV);
	}
	created() {
		var self = this;
		self.fetch();
	}
	fetch() {
		var self = this;
		self.tableConfigs = [];
		let tablesBuffer = [];
		self.isLoading = true;
		api.getTableConfigs(self.tableName)
			.then((res: tableImportMapping[]) => {
				self.tableConfigs = res;
			})
			.finally(() => {
				self.isLoading = false;
			});
	}
	getTables() {
		var self = this;
		self.tables = [];

		api.getTables().then((res: tableItem[]) => {
			self.tables = res;
		});
	}
	onTableCloneSelected(tableName: string) {
		var self = this;
		self.configurations = [];
		self.isLoading = true;
		api.getTableConfigs(tableName)
			.then((res: tableImportMapping[]) => {
				self.configurations = res;
			})
			.finally(() => {
				self.isLoading = false;
			});
	}
	onEdit(t: tableImportMapping) { }
	getPath(t: tableImportMapping) {
		var self = this;
		var p = t;
		return `/settings-tables/${self.tableName}/${t.itemID}`;
	}
	onDelete(t: tableImportMapping) {
		var self = this;
		this.$bvModal
			.msgBoxConfirm(
				`Sei sicuro di eliminare la configurazione ${t.descrizione} ?`,
				{
					headerBgVariant: "warning",
					headerborderVariant: "warning",
					title: "ATTENZIONE",
					okTitle: "SI",
					okVariant: "warning",
					cancelTitle: "NO",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: true
				}
			)
			.then(value => {
				if (value) {
					api.deleteTableConfig(t.itemID).then(res => {
						self.fetch();
					});
				}
			})
			.catch(err => { });
	}
	onNewConfiguration() {
		var self = this;
		self.tableImportMapping = new tableImportMapping();
		self.tableImportMapping.tableName = self.tableName;
		self.saveClicked = false;
		self.showModal = true;
	}
	onNewCloneConfiguration() {
		var self = this;
		self.getTables();

		self.tableImportMapping = new tableImportMapping();
		self.tableImportMapping.tableName = self.tableName;
		self.saveClicked = false;
		self.showModalCopy = true;
	}
	onNewDuplicateConfiguration() {
		var self = this;
		self.getTables();

		self.tableImportMapping = new tableImportMapping();
		self.tableImportMapping.tableName = self.tableName;
		self.saveClicked = false;
		self.showModalDuplicate = true;

		self.configurationsForDuplicate = [];
		self.isLoading = true;
		api.getTableConfigs(this.tableName)
			.then((res: tableImportMapping[]) => {
				self.configurationsForDuplicate = res;
			})
			.finally(() => {
				self.isLoading = false;
			});
	}
	get descrizioneState(): boolean {
		// return null;
		var self = this;
		if (self.saveClicked == false || self.tableImportMapping == null)
			return null;
		return (
			self.tableImportMapping.descrizione != null &&
			self.tableImportMapping.descrizione.trim() != ""
		);
	}
	get importTypeState(): boolean {
		// return null;
		var self = this;
		if (self.saveClicked == false || self.tableImportMapping == null)
			return null;
		return self.tableImportMapping.importType != null;
	}
	onDesrizioneKeyUp(event: KeyboardEvent) {
		var self = this;
		if (
			self.tableImportMapping != null &&
			self.tableImportMapping.descrizione
		) {
			self.tableImportMapping.descrizione = self.tableImportMapping.descrizione.substr(
				0,
				512
			);
		}
	}
	onCancel() {
		var self = this;
		self.showModal = false;
	}
	onCancelClone() {
		var self = this;
		self.showModalCopy = false;
	}
	onCancelDuplicate() {
		var self = this;
		self.showModalDuplicate = false;
	}
	onSave() {
		var self = this;

		var valid = true;
		if (self.tableImportMapping == null) {
			valid = false;
			this.$bvToast.toast("La tipologia di import è obbligatoria", {
				variant: "danger",
				title: "ATTENZIONE",
				solid: true
			});
		}
		if (
			self.tableImportMapping.descrizione == null ||
			self.tableImportMapping.descrizione.trim() == ""
		) {
			valid = false;
			this.$bvToast.toast("La descrizione è obbligatoria", {
				variant: "danger",
				title: "ATTENZIONE",
				solid: true
			});
		}
		if (valid) {
			api.postNewTableConfigs(self.tableImportMapping)
				.then((itemId: number) => {
					self.$router.push({
						path: `/settings-tables/${self.tableName}/${itemId}`
					});
				})
				.finally(() => {
					self.saveClicked = false;
				});
		} else {
			self.saveClicked = true;
		}
	}

	onClone() {
		var self = this;
		if (this.configurationSelected == null) {
			this.$bvToast.toast("Non è stata scelta alcuna configurazione da copiare", {
				variant: "danger",
				title: "ATTENZIONE",
				solid: true
			});

			return;
		}

		api.postNewCloneTableConfigs(self.configurationSelected, self.tableName)
			.then((itemId: number) => {
				self.$router.push({
					path: `/settings-tables/${self.tableName}/${itemId}`
				});
			})
			.finally(() => {
				self.saveClicked = false;
			});
	}
	onDuplicate() {
		var self = this;
		if (this.configurationForDuplicateSelected == null) {
			this.$bvToast.toast("Non è stata scelta alcuna configurazione da duplicare", {
				variant: "danger",
				title: "ATTENZIONE",
				solid: true
			});

			return;
		}

		api.postNewDuplicateTableConfigs(self.configurationForDuplicateSelected, self.tableName)
			.then((itemId: number) => {
				self.$router.push({
					path: `/settings-tables/${self.tableName}/${itemId}`
				});
			})
			.finally(() => {
				self.saveClicked = false;
			});
	}

	onDemandScheduleConfirm(set: tableImportMapping) {
		var self = this;
		this.$bvModal
			.msgBoxConfirm(`Sei sicuro di voler eseguire ORA l'importazione di questa configurazione?`, {
				title: "ATTENZIONE",
				okTitle: "SI",
				cancelTitle: "NO",
				footerClass: "p-2",
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if (value) {
					api.executeOnDemandSettings(set.itemID).then(res => {
						this.$bvToast.toast("L'importazione è in fase di avviamento", {
							variant: "success",
							title: "Operazione eseguita",
							solid: true
						});

						Vue.set(set, "isOnProgressImport", true);

						setTimeout(function () {
							set.isOnProgressImport = false;
						}, 5000)
					});
				}
			})
			.catch(err => { });

		return false;
	}
}
